import { Box, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highcharts'
import { postData } from '../../services/api';

export default function SaleStatisticByItemCatalog({ }) {
    const [data, setData] = useState([])
    const [season, setSeason] = useState('ร้อยละ')

    const [isLoading, setIsLoading] = useState(false)
    const getData = async () => {
        const body = {
            BranchNo: [],
            Season: [],
            TypeNo: [],
            CatalogNo: [],
            BudgetYear: [],
            Month: [],
            Day: []
        }
        setIsLoading(true)
        const res = await postData('dashboard/back/sale-statistic-by-item-catalog-percent', body)
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [])
    return (
        <>
            <div class="row">
                <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "space-between" }}>
                    <h2 className='dash-title'>
                        ผลการจำหน่ายรายพันธุ์
                    </h2>
                    <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "space-between", '& .backgroundField': { background: "#fdb92e" } }}>
                        {/* <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={season}
                                    onChange={e => setSeason(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {['ตัน', 'ร้อยละ']?.map((x, i) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Box> */}
                        <FormControl>
                            <RadioGroup
                                value={season}
                                onChange={e => setSeason(e.target.value)}
                                row
                            >
                                <FormControlLabel value="ร้อยละ" control={<Radio />} label="ร้อยละ" />
                                <FormControlLabel value="ตัน" control={<Radio />} label="ตัน" />
                            </RadioGroup>
                        </FormControl>

                    </Box>
                </Box>
            </div>
            <div class="row">
                {season === 'ตัน' ? <div class="col-12">
                    {!isLoading && <Dashboard dataDashboard={data} />}
                </div> :
                    <div class="col-12">
                        {!isLoading && <Dashboard2 dataDashboard={data} />}
                    </div>}
            </div>
        </>
    )
}
function Dashboard({ dataDashboard }) {

    let category = [];
    let series = [
        {
            name: 'จำหน่ายแล้ว',
            data: [],
            color: '#5ce1e6'
        },
        {
            name: 'คงคลัง',
            data: [],
            color: '#ffdb59'
        },

    ];

    if (dataDashboard.length > 0) {

        for (let i = 0; i < dataDashboard.length; i++) {
            category.push(dataDashboard[i].CatalogName);

            series[1].data.push(+(dataDashboard[i].StockQty / 1000)?.toFixed(2));
            series[0].data.push(+(dataDashboard[i].SoldQty / 1000)?.toFixed(2));
        }

    }
    const options = {
        chart: {
            type: 'column',
            // scrollablePlotArea: {
            //     minWidth: 4000,
            //     scrollPositionX: 1
            // }
            zoomType: 'x'
        },
        title: {
            text: '',
            align: 'left'
        },
        subtitle: {
            text: 'ร้อยละ',
            align: 'left'
        },
        xAxis: {
            categories: category
        },
        yAxis: {

            min: 0,
            title: {
                text: ''
            },
            stackLabels: {
                enabled: true
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -40,
            y: 80,
            floating: true,
            borderWidth: 1,
            backgroundColor:
                Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            shadow: true
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormatter: function () {
                var point = this,
                    series = point.series;

                return `${series.name}: <b>${point.y?.toLocaleString()}</b><br/>Total: ${point.stackTotal?.toLocaleString()}`
            },
        },
        plotOptions: {

            series: {
                // stacking: 'normal',
                // borderRadius: 25
            },
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                stacking: 'percent',
                dataLabels: {
                    enabled: true,
                    color: '#000',
                    style: { fontWeight: 'bolder' },
                    formatter: function () {
                        return this?.y > 0 ? `${this?.y?.toLocaleString()}` : 0
                    },
                    // useHTML: true,
                    inside: true,
                }
            }
        },
        series: series
    }

    return (
        <>
            <>{dataDashboard && <PieChart options={options} highcharts={Highcharts} />}</>
        </>
    )
}
function Dashboard2({ dataDashboard }) {


    let category = [];
    let series = [
        {
            name: 'จำหน่ายแล้ว',
            data: [],
            color: '#5ce1e6'
        },
        {
            name: 'คงคลัง',
            data: [],
            color: '#ffdb59'
        },

    ];

    if (dataDashboard.length > 0) {

        for (let i = 0; i < dataDashboard.length; i++) {
            category.push(dataDashboard[i].CatalogName);

            series[1].data.push(+(dataDashboard[i].StockPercent)?.toFixed(2));
            series[0].data.push(+(dataDashboard[i].SoldPercent)?.toFixed(2));
        }

    }
    const options = {
        chart: {
            type: 'column',

            zoomType: 'x'
        },
        
        title: {
            text: '',
            align: 'left'
        },
        subtitle: {
            text: 'ร้อยละ',
            align: 'left'
        },
        xAxis: {
            categories: category,
          
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            },
            stackLabels: {
                enabled: false
            }
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -40,
            y: 80,
            floating: true,
            borderWidth: 1,
            backgroundColor:
                Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            shadow: true
        },

        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} %</b><br/>',
            shared: true
        },
        plotOptions: {
            column: {
                stacking: 'percent',

                dataLabels: {
                    enabled: true,
                    format: '{point.y} %'
                },

            }
        },
        series: series
    }

    return (
        <>
            <>{dataDashboard && <PieChart options={options} highcharts={Highcharts} />}</>
        </>
    )
}
